export default __webpack_public_path__ + "static/get-your-data-18f5385a648964cf3b52571e892be801.png";